import { Badge, Popover, Button } from '@mantine/core';
import { api } from '~/trpc-extra/api';
import { useAuthStepEdit } from './useAuthStepEdit';
import { useState } from 'react';

export default function StepAccountDetails({ stepId, testContentId }: { stepId: string; testContentId: string }) {
  const { data: account } = api.testStep.getStepAccountDetails.useQuery({ stepId });
  const [opened, setOpened] = useState(false);

  const authStepEdit = useAuthStepEdit({
    stepId,
    testContentId,
  });

  if (!account) {
    return null;
  }

  return (
    <div className="flex items-center gap-2">
      <div>Log in with</div>
      <Popover
        width={300}
        position="bottom-start"
        opened={opened}
        onChange={setOpened}
      >
        <Popover.Target>
          <Badge
            variant="light"
            color="blue"
            className="transition-all duration-200 ease-in-out hover:text-blue-600"
            styles={{ root: { textTransform: 'none', cursor: 'pointer' } }}
            onClick={() => setOpened(!opened)}
          >
            {window.innerWidth < 768 ?
              `${account.name.slice(0, 7)}...`
            : window.innerWidth < 1024 ?
              `${account.name.slice(0, 10)}...`
            : window.innerWidth < 1280 ?
              `${account.name.slice(0, 15)}...`
            : account.name.slice(0, 20)}
          </Badge>
        </Popover.Target>

        <Popover.Dropdown className="space-y-3 rounded-lg border border-gray-200 bg-white shadow-lg">
          {!!account.name && <div className="text-sm font-medium text-gray-900">{account.name}</div>}
          {!!account.userName && (
            <div className="flex items-center space-x-1">
              <p className="text-xs font-medium text-gray-500">Email:</p>
              <p className="text-sm text-gray-900">{account.userName}</p>
            </div>
          )}
          {!!account.password && (
            <div className="flex items-center space-x-1">
              <p className="text-xs font-medium text-gray-500">Password:</p>
              <p className="text-sm text-gray-900">{account.password}</p>
            </div>
          )}
          <div className="pt-2">
            <Button
              size="xs"
              variant="subtle"
              color="blue"
              onClick={() => {
                authStepEdit(account.id);
                setOpened(false);
              }}
            >
              Edit Account
            </Button>
          </div>
        </Popover.Dropdown>
      </Popover>
    </div>
  );
}
